import NutritionInfosSection from "./NutritionInfosSection";

export default NutritionInfosSection;
